module.exports = __webpack_public_path__ + "img/logo_cockpit_color.6c77c02f.png";